import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { ICartModel } from 'interfaces/ICartModel';
import { IProductData, IProductConfig } from 'interfaces/IProductData';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid/Grid';
import React from 'react';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { IStepProps } from './index';
import Payment from 'components/Cart/MainForm/Payment';
import CpfForm from 'components/Cart/MainForm/Payment/PaymentForm/CpfForm';
import { MAX_CREDIT_CARDS } from 'settings';
import Snackbar from '@material-ui/core/Snackbar';
import { FieldValidation } from 'components/Field';
import { SvgIcon } from 'components/SvgIcon';
import HeaderStep from './HeaderStep/index';
import Translate from 'components/Translate';
import get from 'lodash/get';
import AcceptTerms from 'components/AcceptTerms';
import Helmet from 'react-helmet';
import { enPaymentType } from 'enums/enPaymentType';
import PaymentButton from 'components/Cart/PaymentButton';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import OrderBump from '../../../OrderBump';
import { Divider } from '@material-ui/core';
import OpenValue from 'components/Cart/OpenValue';
import Next from 'components/Cart/Next';
import Summary from 'components/Cart/Summary';

interface IState extends IStateBase {
  cart: IProductData;
  model: ICartModel;
  showMessage: boolean;
  snackMessage: string;
  messageButton: string;
  showPaymentMultipleCardsButton: boolean;
}

export interface IProps extends IStepProps {
  onPay: () => void;
  step: number;
}

export default class StepPayment extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ showPaymentMultipleCardsButton: false }, paymentService.showPaymentMultipleCardsButton());
    this.bindModel(paymentService.getCart());

    paymentService
      .getCart()
      .combineLatest(cartService.getCart(), cartService.getConfig())
      .bindComponent(this)
      .subscribe(([payment, cart, config]) => {
        this.setState({ cart });
        this.changeMessageButton(cart, payment, config);
      });
  }

  onValidate(errors: any) {
    this.setState({ validation: errors || {} });
  }

  isValid(): boolean {
    const validation = this.state.validation || {};
    return Object.keys(validation).length === 0;
  }

  finish = async () => {
    if (await this.isFormValid()) {
      this.props.onPay();
    }
  };

  addCreditCard = () => {
    paymentService
      .addPayment()
      .loader()
      .take(1)
      .bindComponent(this)
      .subscribe(res => {
        this.setState({
          showMessage: true,
          snackMessage: 'Um novo cartão foi adicionado'
        });
      });
  };

  showAddCardButton() {
    const isMultipleCreditCards = this.state.cart.config.multipleCreditCards;
    const canAddCreditCard = this.state.model.payment.length < MAX_CREDIT_CARDS && this.state.model.payment.length > 1;

    return isMultipleCreditCards && canAddCreditCard;
  }

  handleClose = () => {
    this.setState({
      showMessage: false
    });
  };

  removeCreditCard = () => {
    this.setState({
      showMessage: true,
      snackMessage: 'O cartão foi removido'
    });
  };

  changeMessageButton = (cart: IProductData, payment: ICartModel, config: IProductConfig) => {
    if (cart.config.paymentType == enPaymentType.FREE) {
      this.setState({ messageButton: 'Obter Gratuitamente' });
      return;
    }

    if (cart.config.paymentType == enPaymentType.SUBSCRIPTION) {
      this.setState({ messageButton: 'Assinar Plano' });
      return;
    }

    if (cart.config.paymentType == enPaymentType.DONATION) {
      this.setState({ messageButton: 'Finalizar' });
      return;
    }

    if (payment.payment[0].paymentMethod == null) {
      const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
      messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
    } else {
      switch (payment.payment[0].paymentMethod) {
        case 'boleto':
          this.setState({ messageButton: 'Gerar Boleto' });
          break;
        case 'paypal':
          this.setState({ messageButton: 'Ir para o PayPal' });
          break;

        default:
          const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
          messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
      }
    }
  };

  render() {
    if (!this.state || !this.state.cart) {
      return '';
    }
    const { messageButton } = this.state;
    const { model, formSubmitted, cart, showPaymentMultipleCardsButton } = this.state;
    const disabledButton = !this.isValid() && formSubmitted;

    return (
      <div>
        <Helmet>
          <body className="step-payment" />
        </Helmet>
        <HeaderStep step={this.props.step} setStep={this.props.setStep} />
        <OpenValue />
        <Divider />
        <div className="step">
          <FieldValidation.Provider value={this.registerFields}>
            <Grid className="grid step-payment" container>
              {cart.pins ? (
                <div className="chk-stepPayment__pin">
                  <QuantityForm isPin={!!cart.pins} />
                </div>
              ) : null}
              <Grid item xs={12}>
                <Next />
              </Grid>

              <div>
                {showPaymentMultipleCardsButton ? (
                  <Grid item xs={12}>
                    <div className="chk-multiple-cards">
                      <Button
                        id="chk-init-multiplecards-button"
                        className={'chk-add-credit-card theme-button'}
                        onClick={this.addCreditCard}
                      >
                        <SvgIcon name="multipleCards" />
                        <Translate term="Pagar com mais cartões?" />
                      </Button>
                    </div>
                  </Grid>
                ) : null}

                {model.payment.map((model, key) => (
                  <Payment
                    key={key}
                    index={key}
                    cardFlagLimit={6}
                    hidePaymentMessage={true}
                    removeCreditCard={this.removeCreditCard}
                  />
                ))}

                <div className="add-card">
                  {this.showAddCardButton() ? (
                    <Button
                      id="chk-add-multiplecard-button"
                      className={'chk-add-credit-card add theme-button'}
                      onClick={this.addCreditCard}
                    >
                      <SvgIcon name="plus" />
                      <Translate term=" Adicionar cartão de pagamento" />
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <Grid className={'cpf-form'} item xs={12}>
                <CpfForm />
              </Grid>

              <Summary />

              <Grid container>
                <Grid item xs={6}>
                  <div className="security">
                    <SvgIcon name="security_check" />
                    <div className="text">
                      <p>
                        <Translate term="Compra" />
                      </p>
                      <p>
                        <Translate term="100% Segura" />
                      </p>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="security">
                    <SvgIcon name="security_finger" />
                    <div className="text">
                      <p>
                        <Translate term="Privacidade" />
                      </p>
                      <p>
                        <Translate term="Protegida" />
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
              {cart.config.paymentType == enPaymentType.SUBSCRIPTION ? (
                <Grid item xs={12}>
                  <AcceptTerms />
                </Grid>
              ) : null}

              <OrderBump />

            </Grid>

            <PaymentButton finish={this.finish} disabledButton={disabledButton} messageButton={messageButton} />

            <Snackbar
              id="chk-cardmessage"
              className={'card-message'}
              open={this.state.showMessage}
              onClose={this.handleClose}
              autoHideDuration={1000}
              message={<Translate term={this.state.snackMessage} />}
            />
          </FieldValidation.Provider>
        </div>
      </div>
    );
  }
}
